import * as Routes from '@/modules/routes';
import type { SlideRow, SlideTableContext } from './types';

const parentParams = ({ parentId, parentType }: SlideTableContext) => ({ parent_id: parentId, parent_type: parentType });

export const editUrl = (slide: SlideRow, context: SlideTableContext) => Routes.builder_admin_slide_show_path(
  context.slideShowId,
  { program_id: context.programId, slide: slide.id, ...parentParams(context) },
);

export const toggleVisibilityUrl = (slide: SlideRow, context: SlideTableContext) => Routes
  .toggle_visibility_admin_slide_path(slide.id, { program_id: context.programId });

// The share link is what a sysadmin pastes elsewhere, so it needs the host; js-routes only emits paths.
export const shareUrl = (slide: SlideRow, context: SlideTableContext) => window.location.origin
  + Routes.edit_shared_slide_show_path(context.slideShowId, {
    lesson_id: context.lessonId, program_id: context.programId, slide_id: slide.id, unit_id: context.unitId,
  });

export const reorderUrl = (context: SlideTableContext) => Routes
  .reorder_admin_slide_show_slides_path(context.slideShowId, { program_id: context.programId });
